import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { QrCode } from 'lucide-react';
import { cn } from '../../../utils/cn';

/** Renders a `upi://pay` link as a scannable QR image. */
export function UpiQrCode({ value, size = 220, className, alt = 'UPI payment QR code' }) {
  const [src, setSrc] = useState('');
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    setFailed(false);
    if (!value) {
      setSrc('');
      return undefined;
    }
    QRCode.toDataURL(value, {
      errorCorrectionLevel: 'M',
      margin: 2,
      width: size * 2,
      color: { dark: '#0f172a', light: '#ffffff' },
    })
      .then((url) => {
        if (alive) setSrc(url);
      })
      .catch(() => {
        if (alive) setFailed(true);
      });
    return () => {
      alive = false;
    };
  }, [value, size]);

  const box = { width: size, height: size };
  if (!value || failed || !src) {
    return (
      <div
        style={box}
        className={cn(
          'flex flex-col items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-slate-200 bg-slate-50 p-4 text-center text-xs font-semibold text-slate-400',
          className
        )}
      >
        <QrCode className="h-8 w-8" aria-hidden />
        {failed
          ? 'Could not draw QR'
          : value
            ? 'Generating QR…'
            : 'QR appears once the UPI ID is valid'}
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      style={box}
      data-upi-qr={value}
      className={cn('rounded-2xl border border-slate-200 bg-white p-1 shadow-sm', className)}
    />
  );
}
